<section class='form-builder-container'>
  <form class="form-builder-form" action="{{form_action_url}}" accept-charset="UTF-8" method="post" {{#if display_thank_you_in_modal}}data-remote="true" data-type="html"{{/if}} {{#if recaptcha}}data-recaptcha="true"{{/if}}>
    <input type="hidden" name="form_submission[form_component_uuid]" value="{{uuid}}" />
    <input type="hidden" name="form_submission[hcmacid]" value="{{hcmacid}}" />
    <input type="hidden" name="form_submission[resource_type]" value="{{resource_type}}" />
    <input type="hidden" name="form_submission[resource_id]" value="{{resource_id}}" />
    <input type="text" name="sparklehp" tabindex="-1" autocomplete="sparklehp" aria-label="Leave this field blank"/>
    <div>
      <div class="form-fields">
        {{#each groups}}
          {{#if fields}}
            <div class="field-input-group {{#if template_option}}field-input-group--{{template_option}}{{/if}}" data-group="field-input-group">
              {{#if label}}<div class="field-input-group__label" data-group="field-input-group-label">{{label}}</div>{{/if}}
              {{#each fields}}
                <dl class="field-input {{type}} field-input--size-{{#if size}}{{size}}{{else}}default{{/if}}">
                  {{> (fbPartial . "type") prefix="form_submission[fields]" }}
                </dl>
              {{/each}}
            </div>
          {{/if}}
        {{/each}}
      </div>
      {{#if review}}
      <div>
        <input type="button"
               data-behaviour="preview-form"
               name="preview"
               value="Preview"
               class="form-preview-button"/>
      </div>
      {{/if}}

      {{#if fields}}
      <input type="submit"
             name="commit"
             value="{{#if submit_text}}{{submit_text}}{{else}}Submit{{/if}}"
             class="submit"
             data-disable-with="Submitting..."/>
      {{/if}}
    </div>
  </form>
</section>

{{#if recaptcha}}
{{!-- {{
  Required by https://developers.google.com/recaptcha/docs/faq#id-like-to-hide-the-recaptcha-v3-badge-what-is-allowed
}} --}}
<footer class="recaptcha-disclaimer">
  <p>
    This site is protected by reCAPTCHA and the Google
    <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and
    <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.
  </p>
</footer>
{{/if}}
